import React from 'react';
import { FormattedMessage } from 'react-intl';
import utils from '../utils/utils';
import DATE_FORMAT from '../components/constants/dateFormat';
import { Link, withRouter } from 'react-router-dom';

const MarketplaceAdminDeliveryDayMarketplaces = ({ deliveryDayMarketplaces, match }) => {
  return (
    <div className="row m-b-6">
      <div className="col-12 col-sm-10 col-md-8 col-lg-6">
        {deliveryDayMarketplaces.map((deliveryDayMarketplace, index) => {
          const deliveryDate = utils.getFormattedDateFromString(
            deliveryDayMarketplace.deliveryDate,
            DATE_FORMAT.displayWithTime
          );
          const deadline = utils.getFormattedDateFromString(
            deliveryDayMarketplace.deadline,
            DATE_FORMAT.displayWithTime
          );

          return (
            <Link key={index} to={`${match.url}/delivery/${deliveryDayMarketplace.id}`}>
              <div className="marketplace-admin__order-group m-b-2">
                <h5 className="marketplace-admin__order-group-date">{deliveryDate}</h5>
                <div>
                  <strong>
                    <FormattedMessage id={'marketplace.admin.delivery.days.deadline'} />
                  </strong>{' '}
                  {deadline}
                </div>
                <div>
                  <strong>
                    <FormattedMessage id={'marketplace.admin.delivery.days.total.sum'} />
                  </strong>{' '}
                  {deliveryDayMarketplace.totalSum}€{' '}
                  {deliveryDayMarketplace.totalSumLimit ? (
                    <span className="text-small text-muted">
                      <FormattedMessage id={'marketplace.admin.delivery.days.total.sum.limit'} />{' '}
                      {deliveryDayMarketplace.totalSumLimit}€
                    </span>
                  ) : (
                    ''
                  )}
                </div>
                {deliveryDayMarketplace.inventoryStatus ? (
                  <div>
                    <strong>
                      <FormattedMessage id={'marketplace.admin.delivery.days.inventory.status'} />
                    </strong>{' '}
                    <FormattedMessage
                      id={`marketplace.admin.delivery.days.inventory.status.${deliveryDayMarketplace.inventoryStatus}`}
                    />
                  </div>
                ) : (
                  ''
                )}
              </div>
            </Link>
          );
        })}

        {deliveryDayMarketplaces.length === 0 ? (
          <p>
            <FormattedMessage id={'marketplace.admin.delivery.days.empty'} />
          </p>
        ) : (
          ''
        )}
      </div>
    </div>
  );
};

export default withRouter(MarketplaceAdminDeliveryDayMarketplaces);
